import React, { useEffect, useRef, useState } from "react";
import Alert from "ui/build/components/Alert/Alert";

import { t } from "../../../utils/ResourceUtils";
import { addMouseMoveAndKeyDownListener } from "./AddMouseMoveAndKeyDownListener";
import EditUserProfile from "./EditUserProfile/EditUserProfile";
import { getUserDetails, updateUserDataByID } from "./EditUserProfile/EditUserProfile.service";
import PopOver from "./PopOver";
import { closeDialog, handleSubmit, logout, newDebouncedMouseMove } from "./UserProfile.utils";

const UserProfile = () => {
  const [userData, setUserData] = useState();
  const [selectedAvatar, setSelectedAvatar] = useState();
  const [showProfileDialog, setShowProfileDialog] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [toast, setToast] = useState({
    alertType: "",
    message: "",
  });
  const [profileDialogOptions, setProfileDialogOptions] = useState({
    heading: "",
    submitText: t("cm.create"),
    cancelText: t("cm.cancel"),
    contentText: "",
    onSubmit: "",
    onCancel: "",
    size: "md",
  });

  const tenantId = localStorage.getItem("tenantId");
  // Refresh token
  const eventTriggeredRef = useRef(false);
  const debouncedMouseMove = newDebouncedMouseMove({ eventTriggeredRef });

  useEffect(() => {
    addMouseMoveAndKeyDownListener(debouncedMouseMove, debouncedMouseMove);
  }, [debouncedMouseMove]);

  const userInfoFun = () => {
    getUserDetails({
      userId: JSON.parse(localStorage.getItem("loginResponse"))?.object?.username,
    })
      .then((res) => {
        res?.data?.userPicURL ? setSelectedAvatar(res?.data?.userPicURL) : setSelectedAvatar("");
        setUserData(res?.data?.object[0]);
      })
      .catch((err) => {
        if (err.response) {
          const statusCode = err.response.status;
          if (statusCode === 401) logout();
        }
      });
  };

  useEffect(() => {
    userInfoFun();
  }, []);

  const openEditProfile = () => {
    setProfileDialogOptions({
      ...profileDialogOptions,
      heading: t("cm.edit_your_profile"),
      submitText: t("cm.save_changes"),
      cancelText: t("cm.cancel"),
      onCancel: () => closeDialog({ userData, setShowProfileDialog, setSelectedAvatar, setDisableBtn }),
      onSubmit: (data) =>
        handleSubmit({ data, tenantId, setShowProfileDialog, setShowAlert, setToast, userInfoFun, updateUserDataByID }),
    });
    setShowProfileDialog(true);
  };

  const handleProfilePic = (profileName) => {
    setSelectedAvatar(profileName);
    setDisableBtn(false);
  };

  const handleSaveProfilePic = (profileName) => {
    setUserData({
      ...userData,
      userPicURL: profileName,
    });
  };

  const handleChange = (e, setFieldValue) => {
    setFieldValue(e.target.name, e.target.value);
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
    setDisableBtn(false);
  };

  return (
    <React.Fragment>
      {showAlert ? (
        <Alert
          alertType={toast.alertType}
          show={showAlert}
          dismiss={true}
          onClose={() => {
            setShowAlert(!showAlert);
          }}
        >
          {toast.message}
        </Alert>
      ) : null}

      <PopOver userData={userData} openEditProfile={openEditProfile} />
      {showProfileDialog && (
        <EditUserProfile
          onCancel={() => closeDialog({ userData, setShowProfileDialog, setSelectedAvatar, setDisableBtn })}
          open={showProfileDialog}
          options={profileDialogOptions}
          userData={userData}
          selectedAvatar={selectedAvatar}
          handleChangeFun={handleChange}
          handleProfilePic={handleProfilePic}
          btnDisable={disableBtn}
          handleSaveProfilePic={handleSaveProfilePic}
        />
      )}
    </React.Fragment>
  );
};

export default UserProfile;
